import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";
import type { ILoaderData } from "@/pages/panelPages/assignStaff/assignStaffForm";

export const assignStaffToDoctorRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.assignStaffToDoctor.route,
      lazy: () => import("@pages/panelPages/assignStaff/assignStaffList"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.assignStaff", [], "index", "main");
        return {};
      },
    },
    permissions: ["local-admin", "super-admin", "admin"],
  },
  {
    route: {
      path: path.assignStaffToDoctorNew.route,
      lazy: () => import("@/pages/panelPages/assignStaff/assignStaffForm"),
      loader: ({ params, request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.assignStaff",
          [
            {
              title: "pageTitle.assignStaff",
              url: path.assignStaffToDoctor.link(),
            },
          ],
          "create",
        );
        return {
          id: Number.parseInt(params.id!),
          facilityId: params.facilityId!,
        };
      },
    },
    permissions: ["admin", "local-admin", "super-admin"],
  },
  {
    route: {
      path: path.assignNewStaffToDoctor.route,
      lazy: () => import("@pages/panelPages/assignStaff/assignStaffForm"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.assignStaff",
          [
            {
              title: "pageTitle.assignStaff",
              url: path.assignStaffToDoctor.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: ["local-admin", "super-admin", "admin"],
  },
  {
    route: {
      path: path.doctors.route,
      lazy: () => import("@/pages/panelPages/assignStaff/doctorsList"),
      loader: ({ params, request }): ILoaderData => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.assignStaff",
          [
            {
              title: "pageTitle.assignStaff",
              url: path.assignStaffToDoctor.link(),
            },
          ],
          "create",
        );
        return {
          id: Number.parseInt(params.id!),
          facilityId: params.facilityId!,
        };
      },
    },
    permissions: ["admin", "local-admin", "super-admin"],
  },
];
